import PageHeader from '../components/PageHeader';
import ListeArticles from '../components/ListeArticles';
import ScrollReveal from '../components/ScrollReveal';

const Boutique = ({ setCurrentSection, currentSection }) => (
  <>
    <PageHeader title="Boutique" subtitle="Articles et services réservés aux adhérents du club"
      setCurrentSection={setCurrentSection} currentSection={currentSection} />
    <section className="section bg-stone-50">
      <div className="max-w-6xl mx-auto">
        <ScrollReveal className="mb-8">
          <span className="tag tag-brand">Réservé aux adhérents</span>
        </ScrollReveal>
        <ScrollReveal delay={0.1}>
          <ListeArticles />
        </ScrollReveal>
      </div>
    </section>
  </>
);

export default Boutique;
